/**
 * Update Domain Handler
 * 
 * CQRS Command Handler that delegates to DomainCommandService.
 * Thin adapter layer that transforms commands to application service calls.
 * 
 * FIXED: No more Inversify - direct constructor injection following party-manager pattern.
 */

import { ICommandHandler } from '@swoft/core';
import { UpdateDomainCommand } from '../commands/UpdateDomainCommand';
import { DomainCommandService } from '../services/DomainCommandService';

export class UpdateDomainHandler implements ICommandHandler<UpdateDomainCommand, void> {
  constructor(
    private readonly domainCommandService: DomainCommandService
  ) {}

  async handle(command: UpdateDomainCommand): Promise<void> {
    await this.domainCommandService.updateDomain(
      command.domainId,
      command.payload,
      command.authSessionId,
      command.initiatedByPersonId,
      command.correlationId
    );
  }
}